import { CSSProperties } from 'react';

import { localeCommon } from '@lib/tools/locale/source/web/common';
import { ILocaleText } from '@lib/tools/locale/views/LocaleFragment';
import { RouteUtils } from '@lib/tools/routes';
import { PAGES } from '@lib/tools/views/urls';

import * as S from '@components/web/src/atoms/Buttons/BackButton/styles';
import { ArrowIcon } from '@components/web/src/atoms/Icons/ArrowIcon';
import { Text } from '@components/web/src/foundations/Text/Text';
import { COLORS } from '@components/web/src/styles';

export type TBackButtonVariant = 'short' | 'long';

interface Props {
  customArrowColor?: string;
  isForModal?: boolean;
  style?: CSSProperties;
  text?: ILocaleText;
  variant?: TBackButtonVariant;
  handleClick: () => void;
}

// TODO: After converting all components that uses this to STYLED
// We remove the STYLES

export const BackButton = ({
  isForModal = false,
  variant = 'short',
  customArrowColor,
  text,
  style,
  handleClick,
  ...rest
}: Props) => {
  const { back, backToCatalog, backToTasteID, backToProduct, goBackBtn } = localeCommon.commonMessages;
  const isVariantLong = variant === 'long';

  let buttonDefaultText: ILocaleText;
  switch (true) {
    case !isForModal:
      buttonDefaultText = isVariantLong ? goBackBtn : back;
      break;
    case RouteUtils.currentPageContains(PAGES.vinhood.catalog):
      buttonDefaultText = backToCatalog;
      break;
    case RouteUtils.currentPageContains(PAGES.vinhood.product):
      buttonDefaultText = backToProduct;
      break;
    case RouteUtils.currentPageContains(PAGES.vinhood.tasteId.tasteId):
      buttonDefaultText = backToTasteID;
      break;
    default:
      buttonDefaultText = isVariantLong ? goBackBtn : back;
      break;
  }

  const arrowSize = isVariantLong ? 'long' : 'short';
  const btnText = text || buttonDefaultText;
  const btnTextSize = isVariantLong ? 'body1' : 'body2';

  return (
    <S.BackButtonContainer $variant={variant} style={style} type="button" onClick={handleClick} {...rest}>
      <ArrowIcon fillColor={customArrowColor} size={arrowSize} />
      <Text color={COLORS.base.black} size={btnTextSize} text={btnText} />
    </S.BackButtonContainer>
  );
};
